// frontend/src/utils/reportHelpers.js
// Funções puras (datas, variação %, junção de séries) usadas pelo ReportDashboard.

export function pad(n) {
    return String(n).padStart(2, "0");
}
export function fmt(d) {
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
// Converte "yyyy-mm-dd" para "dd/mm/yyyy" para exibição
export function fmtBR(iso) {
    if (!iso) return "";
    const [y, m, d] = iso.split("-");
    return `${d}/${m}/${y}`;
}
// Desloca uma data "yyyy-mm-dd" em N anos (usado para calcular "mesmo período do ano anterior")
export function shiftYears(iso, deltaYears) {
    if (!iso) return null;
    const [y, m, d] = iso.split("-").map(Number);
    return fmt(new Date(y + deltaYears, m - 1, d));
}
// Formata variação percentual para exibição (+12,3% / -8,0%)
export function fmtPct(p) {
    if (p === null || p === undefined || !isFinite(p)) return "-";
    const sign = p > 0 ? "+" : "";
    return `${sign}${p.toFixed(1).replace(".", ",")}%`;
}
export function pctChange(cur, prev) {
    const c = Number(cur) || 0;
    const p = Number(prev) || 0;
    if (!p) return c > 0 ? 100 : null;
    return ((c - p) / p) * 100;
}
// Junta duas séries por rótulo (ex.: "dd/mm"), preservando ordem cronológica
// assumindo que os rótulos são "dia/mes" e os dois períodos têm ~1 ano de distância
export function mergeByLabel(rowsA, rowsB, labelField, valueField) {
    const map = new Map();
    rowsA.forEach(r => map.set(r[labelField], { a: Number(r[valueField]) || 0, b: 0 }));
    rowsB.forEach(r => {
        const existing = map.get(r[labelField]) || { a: 0, b: 0 };
        existing.b = Number(r[valueField]) || 0;
        map.set(r[labelField], existing);
    });
    const labels = Array.from(map.keys()).sort((x, y) => {
        const [dx, mx] = x.split("/").map(Number);
        const [dy, my] = y.split("/").map(Number);
        return (mx * 100 + dx) - (my * 100 + dy);
    });
    return {
        labels,
        dataA: labels.map(l => map.get(l).a),
        dataB: labels.map(l => map.get(l).b)
    };
}
// Junta dois rankings (ex.: top lojas/ocorrências) pela união dos itens,
// ordenando pelo total combinado e limitando ao top N
export function mergeRanking(rowsA, rowsB, labelField, valueField, limit = 10) {
    const map = new Map();
    rowsA.forEach(r => map.set(r[labelField], { a: Number(r[valueField]) || 0, b: 0 }));
    rowsB.forEach(r => {
        const existing = map.get(r[labelField]) || { a: 0, b: 0 };
        existing.b = Number(r[valueField]) || 0;
        map.set(r[labelField], existing);
    });
    const merged = Array.from(map.entries())
        .map(([label, v]) => ({ label, a: v.a, b: v.b, total: v.a + v.b }))
        .sort((x, y) => y.total - x.total)
        .slice(0, limit);
    return {
        labels: merged.map(m => m.label),
        dataA: merged.map(m => m.a),
        dataB: merged.map(m => m.b)
    };
}
// Busca JSON autenticado; usado tanto para o período atual quanto para o comparativo
export function fetchJson(url, token) {
    return fetch(url, { headers: { Authorization: "Bearer " + token } }).then(r => {
        if (!r.ok) throw new Error(`HTTP ${r.status} em ${url}`);
        return r.json();
    });
}

export function getRange(preset, customStart, customEnd) {
    const now = new Date();
    const y = now.getFullYear();
    const m = now.getMonth();
    switch (preset) {
        case "este_mes":
            return [fmt(new Date(y, m, 1)), fmt(new Date(y, m + 1, 0))];
        case "mes_passado":
            return [fmt(new Date(y, m - 1, 1)), fmt(new Date(y, m, 0))];
        case "ultimos_3_meses":
            return [fmt(new Date(y, m - 2, 1)), fmt(new Date(y, m + 1, 0))];
        case "este_ano":
            return [fmt(new Date(y, 0, 1)), fmt(new Date(y, 11, 31))];
        case "personalizado":
            return [customStart || null, customEnd || null];
        default:
            return [null, null];
    }
}
